// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Link,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";
import "./Navbar.css";

// Pages
import Home from "./pages/Home";
import Schedule from "./pages/Schedule";
import Roster from "./pages/Roster";
import Gallery from "./pages/Gallery";
import JH from "./pages/JH";
import Accomplishments from "./pages/Accomplishments";

// Assets
import Logo from "./images/Logo.png";

/* 🧭 Scroll to top on route change */
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

/* 🏀 Main App Layout */
function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className={`app-root ${isHome ? "" : "red-bg"}`}>
      {/* =========================
           NAVIGATION BAR
         ========================= */}
      <header className="navbar-modern">
        {/* Left Logo */}
        <div className="nav-left">
          <img
            src={Logo}
            alt="Pottsboro Basketball"
            className="nav-logo-small"
          />
        </div>

        {/* Center Title + Dropdown */}
        <div className="nav-center">
          <Link to="/" className="brand-link">
            <h1 className="nav-title">Pottsboro Basketball</h1>
          </Link>

          <div className="dropdown-modern">
            <button className="dropbtn-modern">
              Menu <span className="drop-arrow">▾</span>
            </button>

            <div className="dropdown-content-modern">
              <NavLink to="/schedule">High School Schedule</NavLink>
              <NavLink to="/roster">High School Roster</NavLink>
              <NavLink to="/jh">Junior High</NavLink>
              <NavLink to="/gallery">Gallery</NavLink>
              <NavLink to="/accomplishments">Accomplishments</NavLink>
            </div>
          </div>
        </div>

        {/* Right Logo */}
        <div className="nav-right">
          <img
            src={Logo}
            alt="Pottsboro Basketball"
            className="nav-logo-small"
          />
        </div>
      </header>

      {/* =========================
           ANIMATED PAGE TRANSITIONS
         ========================= */}
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          className={isHome ? "home-main" : "main-content"}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/roster" element={<Roster />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/jh" element={<JH />} />
            <Route path="/accomplishments" element={<Accomplishments />} />
          </Routes>
        </motion.main>
      </AnimatePresence>
    </div>
  );
}

/* ✅ Final App with Router */
export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}
